





















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { UserProfile } from '../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { NotificationPreferences } from '../models/userdata/notificatonmap';
import { Location } from '../models/userdata/Location';
import multipleLocationSelect from './Commons/multiple-location-search.vue';
import { ChangeEmailRequest } from '../models/userdata/changeemailrequest';
import { ChangePhoneNumberRequest } from '../models/userdata/changephonenumberrequest';
import ConfirmationModal from './Commons/ConfirmationModal.vue';
import RegistrationCard from './Registration/Card.vue';
import CardHeader from './Registration/Header.vue';
import { OtpValidationToken } from '../models/userdata/otptoken';
import { VerificationError } from '@/models/userdata/verificationerror';
import { ChangePhoneNumberConfirmOtpRequest } from '@/models/userdata/changephonenumberconfirmotprequest';
import UpdatePhoneNumberNew from './MyProfile/UpdatePhoneNumberNew.vue';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'MyProfileDetails',
  components: {
    Datepicker,
    VueGoogleAutocomplete,
    multipleLocationSelect,
    RegistrationCard,
    CardHeader,
    UpdatePhoneNumberNew,
  },
})
export default class MyProfileDetails extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private userProfile: UserProfile = new UserProfile();
  private notificationPreference : NotificationPreferences = new NotificationPreferences();
  private birthDate: Date = new Date();
  private address: string = '';
  private map: string = '';
  private viewMode: boolean = true;
  private userProfileBeforeEdit: UserProfile = new UserProfile();
  private uinewpassword: string = '';
  private uioldpassword: string = '';
  private newPasswordHidden: boolean = true;
  private oldPasswordHidden: boolean = true;
  private selectChangePwd: boolean = false;
  private addressFormatUk: boolean = false;
  private desiredLocation: string = '';
  private editEmailFlag: boolean = false;
  private displayEmailPassword: boolean = false;
  private emailPwdText: string = '';
  private newEmail: string = '';
  private newPhoneValid: boolean = false;
  private newPhoneNumber: string = '';
  private newPhone: string = '';
  private editPhoneFlag: boolean = false;
  private displayPhonePassword: boolean = false;
  private phonePwdText: string = '';
  private phoneEdit: boolean = false;
  private editPhoneOnOtpPage: boolean = false;
  private phoneNumber: string = '';
  public phone: string = '';
  private phoneNumberValid: boolean = false;
  private numberErrors = {
    phone: '',
  };
  private otpToken: OtpValidationToken = new OtpValidationToken();
  private VerificationErrors = new VerificationError();
  private noExample: boolean = true;
  private changePhoneOTP: string = '';
  private noOfAttempts: number = 0;
  private fullAddress: string | undefined = '';
  private salaryFreq = [
    { key: 'hour', value: 'Hour' },
    { key: 'time slot', value: 'Time Slot' },
    { key: 'year', value: 'Year' },
    { key: 'week', value: 'Week' },
  ];
  private errors = {
    address1: '',
    city: '',
    state: '',
    zip: '',
  };

  private changePhoneNumberRequest: any;
  private changePhoneNumberDisplayMessage: string = '';

  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;

  @Watch('userProfile.address1')
  @Watch('userProfile.city')
  @Watch('userProfile.state')
  @Watch('userProfile.country')
  @Watch('userProfile.zip')
  addressChange(newVal, oldVal) {
    let disableNextButton = false;
    if (this.minimumEntries >= 0 ? this.isRequiredStep : this.isAddressSectionMandatory) {
      let allMandatoryFieldsEntered =
        (this.locationTypes != '' ?true : this.userProfile.address1) &&
        this.userProfile.city &&
        this.userProfile.state &&
        this.userProfile.country &&
        this.userProfile.zip;
      disableNextButton = !allMandatoryFieldsEntered;
    }
    this.$emit('disable-next-button', disableNextButton);
  }

  get isAddressSectionMandatory() {
    let steps = vxm.users.ProfileWizardSteps;
    let sectionMetaData: any[] = [];
    if (steps && steps.length > 0) {
      sectionMetaData = steps.filter(
        (sectionMeta) => 'ADDRESS' === sectionMeta.stepName,
      );
    }
    if (sectionMetaData && sectionMetaData.length >= 1) {
      return sectionMetaData[0].stepRequired === 1 ? true : false;
    }
    return false;
  }

  @Watch('viewMode')
  onChangeMode(newVal) {
    if (!newVal) {
      this.fullAddress = this.userProfile.getFullAddress();
    }
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }
  setDefaultFontFirstName(){
    setTimeout(()=>{
var copiedText =    this.userProfile.firstName
var formattedString = copiedText.replace(/[^a-zA-Z0-9 ]/g, '')
if(formattedString.length!=copiedText.length){
this.userProfile.firstName = '';

  this.$wlToastr(
      'error',
      this.$t('no.special.characters.allowed.firstname'),
    );

  return false;
}
return true;
    },6)

}
setDefaultFontLastName(){
  setTimeout(()=>{

   var copiedText =   this.userProfile.lastName 

    var formattedString = copiedText.replace(/[^a-zA-Z0-9 ]/g, '');
    console.log(formattedString,"selee")
    if(formattedString.length != copiedText.length){
      
      this.userProfile.lastName = '';
 
      this.$wlToastr(
          'error',
          this.$t('no.special.characters.allowed.lastname'),
        );

        return false;
      
    }
    return true

  },10)

  }
  get locationTypes() {
    if (vxm.jobs.BrandingInfo.VUE_LOCATION_AUTOCOMPLETE_TYPES) { 
      return vxm.jobs.BrandingInfo.VUE_LOCATION_AUTOCOMPLETE_TYPES;
    }
    return '';
  }
  get desiredSalaryText() {
    if (
      this.userProfile.desiredMinSalary &&
      this.userProfile.desiredMaxSalary
    ) {
      return `${this.currency} ${this.userProfile.desiredMinSalary} - ${
        this.currency
      } ${this.userProfile.desiredMaxSalary} ${this.$t('workPreference-payuom-per-label')} ${
        this.userProfile.periodForSalary
      }`;
    }
    if (this.userProfile.desiredMinSalary) {
      return `${this.currency} ${this.userProfile.desiredMinSalary} ${this.$t('workPreference-payuom-per-label')} ${
        this.userProfile.periodForSalary
      }`;
    }
    return '';
  }

  get isSocialMediaSignedInUser() {
    const socialMedias = ['google', 'facebook', 'linkedin'];
    return socialMedias.includes(vxm.users.myUserProfile.sourceType);
  }

  get currency() {
    return this.userProfile.currency || '$';
  }

  get isProfileDetails() {
    return this.$router.currentRoute.name === 'MyProfileDetails';
  }

  get jobAvailabilityOptions() {
    return this.userProfile.jobAvailabilityOptions || [];
  }

  get desiredLocations() {
    return vxm.users.myUserProfile.desiredLocationString
      .substring(0, this.userProfile.desiredLocationString.length - 3)
      .trim();
  }

  onTypingAddress({ newVal = '' } = {}) {
    if (!newVal) {
      this.userProfile.address1 = '';
      this.userProfile.address2 = '';
      this.userProfile.city = '';
      this.userProfile.state = '';
      this.userProfile.country = '';
      this.userProfile.zip = '';
    }
  }

  changePassword() {
    this.uioldpassword = '';
    this.uinewpassword = '';
    this.selectChangePwd = true;
  }

  showEditProfilePage() {
    this.userProfileBeforeEdit.notificationTypeMap =  {... this.userProfile.notificationTypeMap};
    console.log('Edit profile page method called');
    this.selectChangePwd = false;
    this.viewMode = false;
  }

  mounted() {
    this.userProfile = vxm.users.myUserProfile;
    this.userProfileBeforeEdit = Object.assign({}, this.userProfile);
    this.bus.$on('on-next-step', this.onNextStep);
    this.fullAddress = this.userProfile.getFullAddress();
    let locations = this.userProfile.desiredLocations;
    this.phone = this.userProfile.phoneNum;
    for (let index = 0; index < locations.length; index++) {
      if (locations[index].state) {
        this.desiredLocation = this.desiredLocation
          .concat(locations[index].city)
          .concat(',')
          .concat(locations[index].state)
          .concat(',');
      } else {
        this.desiredLocation = this.desiredLocation
          .concat(locations[index].city)
          .concat(',');
      }
    }
  }
  validateAddressSection() {
    if (!this.userProfile.address1) {
      this.errors.address1 = this.$t('myprofile.please-enter-address-line1').toString();
      return false;
    } else {
      this.errors.address1 = '';
    }
    if (!this.userProfile.state) {
      this.errors.state = this.$t('myprofile.please-enter-state').toString();
      return false;
    } else {
      this.errors.state = '';
    }
    if (!this.userProfile.city) {
      this.errors.city = this.$t('myprofile.please-enter-city').toString();
      return false;
    } else {
      this.errors.city = '';
    }
    if (!this.userProfile.zip) {
      this.errors.zip = this.$t('myprofile.please-enter-zip').toString();
      return false;
    } else {
      this.errors.zip = '';
    }
    return true;
  }

  onNextStep({ section }) {
    if (section !== 'user-address' && section !== 'ADDRESS') {
      return;
    }
    vxm.users
      .saveUserProfile({
        userProfile: this.userProfile,
        isPartofRegistration: false,
      })
      .then(async (response) => {
        await vxm.users.getProfileStrength();
        if (response.success) {
          this.$wlToastr(
            'success', 
            this.$t('myprofile.address.updated.message'), 
            this.$t('myprofile.address.title')
          );
          this.$emit('go-to-next');
        } else {
          this.$wlToastr(
            'error',
            `${this.$t('something.went.wrong')}. ${this.$t('please.try.again')}`,
            this.$t('myprofile.address.title'),
          );
        }
      });
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  saveUserProfile() {
    const vm = this;
    vm.userProfile.newPassword = this.uinewpassword;
    vm.userProfile.oldPassword = this.uioldpassword;
    console.log(
      'new password:' +
        vm.userProfile.newPassword +
        ' old password:' +
        vm.userProfile.oldPassword,
    );
    const respPromise: any = vxm.users.saveUserProfile({
      userProfile: this.userProfile,
      isPartofRegistration: false,
    });
    Promise.all([respPromise]).then(async (values) => {
      if (!values[0].success) {
        console.log('pwd error:' + values[0].errorMessage);
        if (values[0].errorMessage == 'Old password entered is wrong')
          vm.$wlToastr(
            'error',
            vm.$t('myprofile.message.wrongoldpassword'),
            vm.$t('UserProfile_MyProfile').toString(),
          );
        else
          vm.$wlToastr(
            'error',
            values[0].errorMessage,
            vm.$t('UserProfile_MyProfile').toString(),
          );
        this.selectChangePwd = false;
      } else {
        vm.$wlToastr(
          'success',
          vm.$t('myprofile.update.sucess'),
          vm.$t('UserProfile_MyProfile').toString(),
        );
        await vxm.users.refreshProfileInfo();
        this.userProfile = vxm.users.myUserProfile;
        this.userProfileBeforeEdit = vxm.users.myUserProfile;
      }
    });
  }

  getAddressData(addressData, placeResultData, id) {
    let town: string = '';
    if (placeResultData.address_components) {
      placeResultData.address_components.forEach((item, idx) => {
        if (item.types[0] == 'postal_town') {
          town = item.long_name;
        }
      });
    }
    this.address = addressData;
    this.userProfile.zip = addressData.postal_code || '';
    this.userProfile.country = addressData.country || '';
    this.userProfile.address1 = `${addressData.street_number ||
      ''} ${addressData.route || ''}`;
    this.userProfile.address2 = '';
    this.userProfile.city = addressData.locality || town;
    this.userProfile.state = addressData.administrative_area_level_1 || '';
  }

  cancelChanges() {
    this.selectChangePwd = false;
    Object.assign(this.userProfile, this.userProfileBeforeEdit);
    this.viewMode = true;
    this.editEmailFlag = false;
    this.displayEmailPassword = false;
  }

  setNotificationPreference(userProfile){
    this.notificationPreference.email = userProfile.notificationTypeMap.EMAIL;
    this.notificationPreference.sms = userProfile.notificationTypeMap.SMS;
    this.notificationPreference.push = userProfile.notificationTypeMap.PUSH_NOTIFICATION;
    this.notificationPreference.voice = userProfile.notificationTypeMap.VOICE;
    vxm.notificationpreference.setUserNotificationPreference(this.notificationPreference);
  }

  updateChanges() {
    this.setDefaultFontFirstName();
    this.setDefaultFontLastName();
    setTimeout(()=>{
      vxm.users.refreshPhoneNumber().then((data) => {
      console.log(this.userProfile);
      if (this.validateUserProfileData(this.userProfile)) {
        this.setNotificationPreference(this.userProfile);
        this.saveUserProfile();
        this.updateDesiredLocation();
        this.viewMode = true;
      } else {
        this.$wlToastr(
          'error',
          this.$t(this.errorString),
          this.$t('UserProfile_MyProfile').toString(),
        );
      }
    });
  },6)
  }

  updateDesiredLocation() {
    let locationsElement = this.$el.querySelectorAll('multiselect__tags-wrap');
    console.log('Location element' + locationsElement);
  }
  saveChanges() {
    console.log(this.userProfile);
    if (this.validateUserProfileData(this.userProfile)) {
      this.saveUserProfile();
    } else {
      this.$wlToastr(
        'error',
        this.$t(this.errorString),
        this.$t('UserProfile_MyProfile').toString(),
      );
    }
  }

  desiredSalaryVerify(userProfile: UserProfile): boolean {
    if (!userProfile.desiredMinSalary && !userProfile.desiredMaxSalary) {
      return true;
    }
    if (!userProfile.desiredMinSalary && userProfile.desiredMaxSalary) {
      this.errorString = 'Minimum salary cannot be empty.';
      return false;
    }

    if (userProfile.desiredMinSalary && !userProfile.desiredMaxSalary) {
      userProfile.desiredMaxSalary = userProfile.desiredMinSalary;
    }

    if (userProfile.desiredMinSalary.match(new RegExp('[a-zA-Z*&+_^#@-]'))) {
      this.errorString = 'Invalid desired minimum salary.';
      return false;
    }
    if (userProfile.desiredMaxSalary.match(new RegExp('[a-zA-Z*&+_^#@-]'))) {
      this.errorString = 'Invalid desired maximum salary.';
      return false;
    }
    // if (
    //   !userProfile.desiredMinSalary.match(
    //     new RegExp('[0-9]{2,}[.]?[0-9]{0,}$', 'g'),
    //   )
    // ) {
    //   this.errorString = 'Invalid desired minimum salary.';
    //   return false;
    // }
    // if (
    //   !userProfile.desiredMaxSalary.match(
    //     new RegExp('[0-9]{2,}[.]?[0-9]{0,}$', 'g'),
    //   )
    // ) {
    //   this.errorString = 'Invalid desired maximum salary.';
    //   return false;
    // }
    var maxSal = parseInt(
      userProfile.desiredMaxSalary.replace(userProfile.currency, ''),
    );
    var minSal = parseInt(
      userProfile.desiredMinSalary.replace(userProfile.currency, ''),
    );

    if (maxSal < minSal) {
      this.errorString = 'workpreference.minsal.greater.than.maxsal';
      return false;
    }
    this.userProfile.desiredMaxSalary =
      this.userProfile.currency + maxSal.toFixed(1);
    this.userProfile.desiredMinSalary =
      this.userProfile.currency + minSal.toFixed(1);
    return true;
  }

  validateUserProfileData(userProfile: UserProfile): boolean {
    if (!userProfile.firstName) {
      this.errorString = 'myprofile.firstname.required';
      return false;
    }

    if (!userProfile.lastName) {
      this.errorString = 'myprofile.lastname.required';
      return false;
    }
    if (this.selectChangePwd) {
      if (!this.uioldpassword) {
        this.errorString = 'myprofile.oldpassword.required';
        return false;
      }
      if (!this.uinewpassword) {
        this.errorString = 'myprofile.newpassword.required';
        return false;
      } else {
        const hasNumber = this.uinewpassword.match(/\d+/g);
        const hasLetter = this.uinewpassword.match(/[a-zA-Z]/g);
        const hasUpperCase = this.uinewpassword.match(/[A-Z]/g);
        const hasSpecialCharacter = this.uinewpassword.match(
          /[*@!#%&()^~{}]+/g,
        );
        if (
          this.uinewpassword.length <
            vxm.configs.getGlobalConfigValue('MIN_PASSWORD_LENGTH') ||
          (hasNumber == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_NUMBER_CHARS')) ||
          hasLetter == null ||
          (hasUpperCase == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_UPPERCASE_CHARS')) ||
          (hasSpecialCharacter == null &&
            !!vxm.configs.getGlobalConfigValue('MIN_SPECIAL_CHARS'))
        ) {
          this.errorString = vxm.utility.passwordConditions;
          return false;
        }
      }
    }
    return true && this.desiredSalaryVerify(userProfile);
  }

  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
    return true;
  }

  resendActivationEmail() {
    const respPromise: any = vxm.users.changePhoneNumber(
      this.changePhoneNumberRequest,
    );
    const resp = respPromise.then((resp) => {
      if (resp.meta.success) {
        this.$wlToastr(
          'success',
          this.$t('activation-link-resent-successfully'),
          this.$t('UserProfile_MyProfile').toString(),
        );
        this.$modal.hide('emailverificationcode-popup');
      } else {
        this.$wlToastr(
          'error',
          resp.data.errorMessage,
          this.$t('UserProfile_MyProfile').toString(),
        );
      }
    });
  }

  beforeOpenEmailverificationcodePopup($event) {
    this.changePhoneNumberRequest = $event.params.changePhoneNumberRequest;
    this.changePhoneNumberDisplayMessage = $event.params.displayMessage;
  }

  getJobavaibility(event) {
    this.userProfile.jobAvailability = event.target.value;
  }
  setPeriodForSalary(event) {
    this.userProfile.periodForSalary = event.target.value;
  }
  
  preventFloatInput(event) {
    if (['.', '-', '+', 'e'].includes(event.key)) {
      event.preventDefault();
    }
  }

  setRemoteWork(event) {
    this.userProfile.remoteWork = event.target.value == 'No' ? false : true;
  }

  hideNewPassword() {
    this.newPasswordHidden = true;
  }

  showNewPassword() {
    this.newPasswordHidden = false;
  }

  hideOldPassword() {
    this.oldPasswordHidden = true;
  }

  showOldPassword() {
    this.oldPasswordHidden = false;
  }

  editEmail() {
    if (
      this.userProfile.sourceType == null ||
      this.userProfile.sourceType.trim().length == 0 ||
      this.userProfile.sourceType == 'email'
    )
      this.editEmailFlag = true;
  }

  displayEditEmailIcon() {
    return (
      this.userProfile.sourceType == null ||
      this.userProfile.sourceType.trim().length == 0 ||
      this.userProfile.sourceType == 'email'
    );
  }

  cancelEmailEdit() {
    this.editEmailFlag = false;
    this.displayEmailPassword = false;
  }

  showEmailPassword() {
    this.displayEmailPassword = true;
  }

  hideEmailPassword() {
    this.displayEmailPassword = false;
  }

  async saveEmailEdit() {
    const vm = this;
    console.log(
      'new email:' + this.newEmail + ' password:' + this.emailPwdText,
    );
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!this.newEmail) {
      this.newEmail = 'signup.email.required';
      return;
    }
    if (!this.newEmail.match(emailformat)) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.enter.valid.email'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }
    this.viewMode = true;
    this.editEmailFlag = false;
    this.displayEmailPassword = false;
    var changeEmailRequest = new ChangeEmailRequest();
    changeEmailRequest.newEmail = this.newEmail;
    changeEmailRequest.confirmPassword = this.emailPwdText;
    // vxm.users.changeEmailAddress(changeEmailRequest);

    const respPromise: any = vxm.users.changeEmailAddress(changeEmailRequest);
    const resp = await respPromise;
    if (resp.success) {
      vm.$wlToastr(
        'success',
        vm.$t('check-your-inbox-to-validate-email'),
        vm.$t('UserProfile_MyProfile').toString(),
      );

      vxm.users.logout();
      console.log(vxm.users.isLoggedIn);
      this.$router.push(
        vxm.configs.getGlobalConfigBooelanValue('DEFAULT_CANDIDATE_LANDING_PAGE_AS_LOGIN')
          ? '/login'
          : '/',
      );
    } else {
      let toasterMessage = resp.errorMessage;
      if (resp.errorCode && resp.errorCode==1519) 
      toasterMessage = this.$t('errorcode.1519').toString();
      if (resp.errorCode && resp.errorCode==1518) 
      toasterMessage = this.$t('errorcode.1518').toString();
      if (resp.errorCode && resp.errorCode==2115) 
      toasterMessage = this.$t('errorcode.2115').toString();
      vm.$wlToastr(
        'error',
        toasterMessage,
        vm.$t('UserProfile_MyProfile').toString(),
      );
    }
  }

  editPhone() {
    this.editPhoneFlag = true;
  }

  showPhonePassword() {
    this.displayPhonePassword = true;
  }

  hidePhonePassword() {
    this.displayPhonePassword = false;
  }

  cancelPhoneEdit() {
    this.editPhoneFlag = false;
    this.displayPhonePassword = false;
  }

  async savePhoneEdit() {
    const vm = this;

    if (!this.newPhoneNumber) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.required'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }

    if (!this.newPhoneValid) {
      vm.$wlToastr(
        'error',
        vm.$t('signup.phone.valid'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }

    if (!this.phonePwdText) {
      vm.$wlToastr(
        'error',
        vm.$t('myprofile.please-enter-password'),
        vm.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }
    this.viewMode = true;
    this.editPhoneFlag = false;
    this.displayPhonePassword = false;

    console.log(
      'new phone:' + this.newPhoneNumber + ' password:' + this.phonePwdText,
    );
    var changePhoneNumberRequest = new ChangePhoneNumberRequest();
    changePhoneNumberRequest.newPhone = this.newPhoneNumber;
    const respPromise: any = vxm.users.changePhoneNumber(
      changePhoneNumberRequest,
    );
    const resp = await respPromise;
    if (resp.success) {
      if (
        vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION') &&
        vxm.configs.getGlobalConfigValue('STAGES_TO_SKIP_OTP_VERIFICATION').includes('1')
      ) {
        this.$wlToastr(
          'success',
          this.$t('phone-number-has-been-updated'),
          this.$t('change-ph-number-text').toString(),
        );
        await vxm.users.updatedUserProfile();
      } else {
        this.$modal.show('edit-phone');
      }
      if (this.editPhoneOnOtpPage) {
        vm.$wlToastr(
          'success',
          vm.$t('new-verification-code-sent').toString(),
          vm.$t('change-ph-number-text').toString(),
        );
        this.phoneEdit = false;
      }
    } else {
      vm.$wlToastr(
        'error',
        resp.errorMessage,
        vm.$t('UserProfile_MyProfile').toString(),
      );
    }
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get companyName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME')
  }

  editPhonePopup() {
    this.phoneEdit = true;
  }

  updateVerificationOtpPhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    this.phone = '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.phoneNumberValid = event.isValid;
  }

  submitChangePhone() {
    if (this.phone.length !== 10 || isNaN(Number(this.phone))) {
      this.numberErrors.phone = 'signup.phone.valid';
      return;
    }
    let companycode = vxm.jobs.BrandingInfo.companycode;
    let phoneNumber = this.phone;
    let countryCode = '+1';
    countryCode = encodeURIComponent(countryCode);
    let email = encodeURIComponent(vxm.users.myUserProfile.email);
    const changeNumberCount = '1';
    let url = `/wl-sso-sec-svc/api/user/changeNumber?companycode=${companycode}&email=${email}&phone=${phoneNumber}&changeNumberCount=${changeNumberCount}&countrycode=${countryCode}`;
    vxm.users.changeNumber(url).then((resp) => {
      if (resp.status === 'success') {
        this.phoneEdit = false;
        this.phoneNumber = resp.phone;
        this.$wlToastr(
          'info',
          this.$t('new-verification-code-sent'),
          this.$t('changenumber.toast.title'),
        );
      } else {
        this.$wlToastr(
          'error',
          this.$t('ph-number-change-err-msg'),
          this.$t('changenumber.toast.title'),
        );
      }
    });
  }

  continueOTP() {
    if (!this.validateOtp()) {
      return;
    }
    this.noOfAttempts = this.noOfAttempts + 1;
    const vm = this;
    this.otpToken.userIdStr = vxm.users.myUserProfile.email;
    this.otpToken.failureCount = '0';
    this.otpToken.failedAttemptCount = 0;
    this.otpToken.companyCode = vxm.jobs.BrandingInfo.companycode;
    var changePhoneNumberConfirmOtpRequest = new ChangePhoneNumberConfirmOtpRequest();
    changePhoneNumberConfirmOtpRequest.code = this.otpToken.otp;
    if (vm.isLoggedIn) {
      vxm.users.confirmOtp(changePhoneNumberConfirmOtpRequest).then((value) => {
        if (value.success) {
          vm.$wlToastr(
            'success',
            vm.$t('phone.number.changed.success').toString(),
            vm.$t('verification.toast.title'),
          );
          vxm.users.refreshProfileInfo();
          this.$modal.hide('edit-phone');
          this.newPhone = '';
          this.newPhoneNumber = '';
          this.newPhoneValid = false;
          this.phonePwdText = '';
          this.otpToken = new OtpValidationToken();
          this.resetAttempts();
        } else {
          vm.VerificationErrors.otpToken = value.errorMessage;
          if (this.noOfAttempts >= 2) {
            vm.$wlToastr(
              'error',
              vm.$t('exceeded.number.of.attempts').toString(),
              vm.$t('verification.toast.title'),
            );
            this.$modal.hide('edit-phone');
            this.resetAttempts();
          }
        }
      });
    }
  }

  resetAttempts() {
    this.noOfAttempts = 0;
  }

  validateOtp() {
    this.VerificationErrors.otpToken = '';
    if (!this.otpToken.otp || this.otpToken.otp.length < 5) {
      this.VerificationErrors.otpToken = this.$t(
        'verification.otp.validation.message',
      );
      return false;
    } else {
      return true;
    }
  }

  skipVerification() {
    this.resetAttempts();
    this.newPhone = '';
    this.newPhoneNumber = '';
    this.newPhoneValid = false;
    this.phonePwdText = '';
    this.otpToken = new OtpValidationToken();
    this.$modal.hide('edit-phone');
  }

  resendEventHandler() {
    this.resetAttempts();
    this.otpToken = new OtpValidationToken();
    this.VerificationErrors.otpToken = '';
    vxm.users.changePhoneNumberResendOTP().then((value) => {
      if (value.success) {
        this.$wlToastr(
          'info',
          this.$t('resent-otp-success-msg').toString(),
          this.$t('verification.toast.title'),
        );
      } else {
        console.log('cannot resend OTP');
        const errorMessage = value.errorMessage;
        this.$wlToastr(
          'error',
          errorMessage,
          this.$t('verification.toast.title'),
        );
      }
    });
  }

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    this.newPhoneNumber =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.newPhoneValid = event.isValid;
  }

  updateCandidatePhoneOtpPage(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    this.newPhoneNumber =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.newPhoneValid = event.isValid;
    this.editPhoneOnOtpPage = true;
  }
}
